<div class="selector" [class.active]="isActive" (click)="writeValue()">
  <div class="selector-check"></div>
  <div class="selector-body">
    <ng-content></ng-content>
  </div>
</div>
